
var util = require('../../util/property-util');
var AlarmObjects = require('../pages/alarm/alarmObjects');
var DeviceTypes = require('../pages/alarm/deviceTypes');
var fabric = require('fabric').fabric;

module.exports = /*@ngInject*/ ["$q", "$rootScope","$injector", function ($q, $rootScope, $injector) {
    return {
        restrict: 'AE',
        scope: {
            train: '<',
            deviceCollection: '=',
            selectedHashCode: '='
        },
        template: [` 
        <div ng-if="train" class="container-fluid p-0">
            <canvas id="trainCanvas" class="w-100" style="background-color: #f0f0f0"></canvas>
        </div>
        <div ng-if="!train" class="text-center">
            <i class="fa fa-2x fa-spinner fa-pulse"></i>
        </div>
        `],

        link: function (scope, element, iAttrs, train) {
            var data;
            var titleHeight = 10;
            var images = [];


            $injector.get('monitoringBehaviorSubjectService').changeOccured.subscribe((transaction) => {
                if (transaction) {
                  switch (transaction.action) {
                    case 'current-train-updated':
                        scope.$parent && scope.$parent.$digest()
                    break;
                  }
                }
              })

            scope.$watch('train', function (newValue) { 
                if (util.isDefined(newValue)) {
                    data = newValue;
                    alerts = [];
                    images = [];
                    hoverAlert = undefined;

                    drawConsistLayout(scope, element, data);
                }
            }, false);

            function calculateCanvasDimensions() { //Will calculate the dimensions of the canvas based on the width/height ratio of the images
                var canvas = document.getElementById("trainCanvas");
                var divHeight = element.parent().prop('offsetHeight');
                var divWidth = element.parent().prop('offsetWidth');
                var numberOfImages = 2;

                if (data && data.images && data.images.length === 1) {
                    numberOfImages = 1;
                }
                canvas.height = divHeight;

                var imageAvailableHeight = canvas.height / numberOfImages - titleHeight;
                var scaling = images[0] ? imageAvailableHeight / images[0].height : 1;
                canvas.width = images[0] ? images[0].width * scaling : 1;

                if (canvas.width > divWidth) {
                    var tmp = canvas.width;
                    canvas.width = divWidth;
                    scaling = tmp / canvas.width;
                    canvas.height = canvas.height / scaling;
                }
                drawAlerts(data)
            }

            function drawAlerts(data) { //Draw all text and devices on the canvas
                var canvas = document.getElementById("trainCanvas");
                var ctx = canvas.getContext("2d");
                var xScale = canvas.width / 100;
                var yScale = canvas.height / 100;
                var calcTitleHeight = data.showHeaders ? titleHeight : 0;
                var coachTitleHeight = calcTitleHeight * yScale;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (data.images && data.images.length === 1) {
                    ctx.drawImage(images[0], 0, coachTitleHeight, canvas.width, canvas.height - coachTitleHeight);
                } else {
                    ctx.drawImage(images[0], 0, coachTitleHeight, canvas.width, canvas.height / 2 - coachTitleHeight);
                    ctx.drawImage(images[1], 0, coachTitleHeight + canvas.height / 2, canvas.width, canvas.height / 2 - coachTitleHeight);
                }

            }

            $(window).resize(resize);

            function resize() {
                if (data) {

                    if (!drawConsistLayout(scope, element, data)) {
                        // draw classical
                        if (data.images) {
                            calculateCanvasDimensions();
                        }
                    }
                }
            }

            scope.$on("$destroy", function () {
                $(window).off("resize", resize);
            });


            /**
             * Tries to draw the TrainConsist in a new way (dynamic or static).
             *
             * @param element
             * @param data
             *
             * @returns {boolean} true when able to draw, false when failed to draw.
             */
            function drawConsistLayout(scope, element, data) {

                // create the device mappings.
                const deviceDescriptions = createDeviceDescriptions(data);

                var dc; // stupid test runner doesn't allow let !
                scope.deviceCollection = undefined;

                if (data && data.trainConsistView && data.trainConsistView.gridSize && data.trainConsistView.deviceTypes) {
                    dc = prepareCanvasDrawingContext(element, data.trainConsistView.gridSize, data.trainConsistView.drawingContextParameters);
                }

                if (data && data.trainConsistView && data.trainConsistView.deviceTypes) {
                    DeviceTypes.createInstance(data.trainConsistView.deviceTypes);
                }

                if (!util.isDefined(dc)) { // if dc is undefined -> classical way.
                    return false;
                } else if (util.isDefined(data.trainConsistView.staticConsistLayout)) { // static consist
                    //drawFrameAroundCanvas(dc);

                    //Add a painted coach ID for each "coach" device.
                    data.trainConsistView.staticConsistLayout.deviceLayouts
                        .filter(deviceLayout => deviceLayout.type === "coach")
                        .map(deviceLayoutCoach => {
                            data.train.deviceGroups
                                .filter(deviceGroup => deviceGroup.name.replace('Coach', '').trim() === deviceLayoutCoach.coach.toString())
                                .map(matchedCoachDeviceGroup => {
                                    deviceLayoutCoach.paintedCoachId = matchedCoachDeviceGroup.paintedCoachId;
                                })
                            })

                    if (!data.dynamicConsist) {
                        scope.deviceCollection = updateStaticCanvas(dc, data.trainConsistView.staticConsistLayout.deviceLayouts, deviceDescriptions);
                    } else {
                        if (data && data.train && data.trainConsistView && data.trainConsistView.staticConsistLayout) {
                            data.trainConsistView.staticConsistLayout.deviceLayouts = data.trainConsistView.staticConsistLayout.deviceLayouts.map((layout, order) => {
                                return {
                                    ...layout,
                                    order
                                }
                            })
                            data.trainConsistView.staticConsistLayout.deviceLayouts = data.trainConsistView.staticConsistLayout.deviceLayouts.filter(device => {
                                return !!data.train.deviceGroups.find(deviceGroup => deviceGroup.name.replace('Coach', '').trim() === device.coach.toString())
                            })
                            var deviceLayouts = data.train.deviceGroups.reduce((acc, deviceGroup) => {
                                var currentCoach = data.trainConsistView.staticConsistLayout.deviceLayouts.find(layout => {
                                    return deviceGroup.name.toLowerCase() === (layout.type + ' ' + layout.coach).toLowerCase()
                                });
                                var currentGroupDevices = deviceGroup.devices.map(device => {
                                    return data.trainConsistView.staticConsistLayout.deviceLayouts.find(layout => {
                                        return device.hostname.endsWith(layout.id) && device.coachId === layout.coach;
                                    });
                                });
                                return [
                                    ...acc,
                                    currentCoach,
                                    ...currentGroupDevices
                                ];
                            }, []);
                        }
                        deviceLayouts = deviceLayouts.sort((l1,l2) => l1.order - l2.order).filter(device => !!device);
                        
    
                        var tmpDeviceLayouts = [...deviceLayouts];
    
                        deviceLayouts  = deviceLayouts.map(layout => {
                            if (layout.position.object ) {
                                var matchedLayout = tmpDeviceLayouts.find(device => device && device.id === layout.position.object.split('.')[0])
                                if (!matchedLayout) {
                                    layout.position = {
                                        bounds: null,
                                        center: null,
                                        distance: 0,
                                        object: 'R'+ layout.coach,
                                        position: {
                                            bounds: null,
                                            center: {
                                                x: "50%",
                                                y: "30%"
                                            },
                                            distance: 0,
                                            object: null,
                                            position: null,
                                            type: "percentage"
                                        },
                                        type: "relative"
                                    }
                                }
                            }
    
    
                            layout.connections = layout.connections && layout.connections.map(connection => {
                                var sourceExist = connection.source.split('.')[0] ? !!tmpDeviceLayouts.find(device => device && device.id === connection.source.split('.')[0]) : true 
                                var targetExist = connection.source.split('.')[0] ? !!tmpDeviceLayouts.find(device => device && device.id === connection.target.split('.')[0]) : true
                                connection.source = sourceExist ? connection.source : null;
                                connection.target = targetExist ? connection.target : null;
                                return connection;
                            })
                            
                            return layout;
    
                        });
    
                        scope.deviceCollection = updateStaticCanvas(dc, deviceLayouts, deviceDescriptions);
                    }
                } else {
                    scope.deviceCollection = updateDynamicCanvas(dc, data.train, data.trainConsists, deviceDescriptions);
                }

                return true;
            }

            /**
             * Prepares the canvas, based on the element where the Canvas is placed in.
             * Adapts the size to the acceptable size in the browser.
             * Created a DrawingContext that can be used to layout the elements.
             *
             * @param element the element where canvas is placed in.
             * @param gridSize the size we use to express the elements in. This is scaled to the allowed space.
             * @param drawingContextParameters parameters to configure DrawingContext object.
             *
             * @returns {DrawingContext}
             */
            function prepareCanvasDrawingContext(element, gridSize, drawingContextParameters) {
                const divHeight = element.parent().prop('offsetHeight');
                const divWidth = element.parent().prop('offsetWidth');

                const gridWidth = gridSize.width;
                const gridHeight = gridSize.height;

                const scaleWidth = divWidth / gridWidth;
                const scaleHeight = divHeight / gridHeight;

                const scale = (scaleWidth < scaleHeight) ? scaleWidth : scaleHeight;

                const canvas = document.getElementById("trainCanvas");
                if (canvas) {
                    canvas.width = (gridWidth * scale);
                    canvas.height = (gridHeight * scale);
                }


                // create a drawing context
                const fabricCanvas = new fabric.StaticCanvas('trainCanvas');
                const dc = new AlarmObjects.DrawingContext(fabricCanvas, scale, gridSize, drawingContextParameters);
                fabricCanvas.dc = dc;

                return dc;
            }

            function updateStaticCanvas(dc, devicesLayout, deviceDescriptions) {

                // layout and draw the devices.
                const deviceCollection = new AlarmObjects.DeviceCollection();
                const gridSize = dc.gridSize;
                const devices = deviceCollection.layoutDevices(devicesLayout, gridSize, deviceDescriptions);

                devices.forEach(function (device) {
                    device.draw(dc);
                });

                deviceCollection.dc = dc;
                deviceCollection.deviceDescriptions = deviceDescriptions;
                return deviceCollection;
            }


            function updateDynamicCanvas(dc, train, dynamicConsist, deviceDescriptions) {

                // layout and draw the devices.
                const deviceCollection = new AlarmObjects.DeviceCollection();
                const gridSize = dc.gridSize;
                const devices = deviceCollection.layoutDynamicConsist(train, dynamicConsist, gridSize, deviceDescriptions);

                devices.forEach(function (device) {
                    device.draw(dc);
                });

                deviceCollection.dc = dc;
                deviceCollection.deviceDescriptions = deviceDescriptions;
                return deviceCollection;
            }

            /**
             * Flattens the specified train zabbix data format to a DeviceDescriptions object.
             * A deviceDescriptions object contains a descriptions array, where every field maps to a (zabbix) component.
             * (the elements in the components array of every coach of data).
             *
             * For example: if there is a device with hostname 1_1070_MAR3-B1, a device description will be made with key MAR3-B1
             * and the value is the aformentioned device.
             *
             * This maps the device in the layout to the zabbix device.
             *
             * @param data contains an array of objects, which represent coaches (rames).
             * Every coach has a components array, containing a device in that coach.
             * Data is created in alarmMonitoringPageController.createCanvasDataSet.
             *
             * @return DeviceDescriptions object containing all device data.
             */
            function createDeviceDescriptions(data) {

                const train = data && data.train;
                const deviceDescriptions = new AlarmObjects.DeviceDescriptions();

                // add Train to deviceDescription under "ALL"
                deviceDescriptions.addDescription("ALL", train);

                const allDevices = train && train.allDevices;
                if (allDevices) {
                    allDevices.forEach(function (device) {
                        const hostname = device.hostname;
                        const coachId = device.coachId;
    
                        if (util.isDefined(hostname)) {
                            const deviceId = hostname.replace(/[0-9]+_[0-9]+_/g, '');
                            deviceDescriptions.addDescription(deviceId, coachId, device);
                        }
    
                    });
                }

                return deviceDescriptions;
            }
        }
    }
}];






